import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getIsAuthenticated } from 'store/user/userSelectors';
import { QH_SELF_SERVICE_URL } from 'config';
import { HeaderInternalLink, HeaderList, HeaderListItem } from './primitives';
import HeaderLinks from 'components/Header/HeaderLinks';

const NavigationLinks = ({ setIsPhoneMenuOpen, setIsQffMenuOpen }) => {
  const isAuthenticated = useSelector(getIsAuthenticated);

  return (
    <HeaderList>
      {isAuthenticated && (
        <HeaderListItem>
          <HeaderInternalLink
            href={`${QH_SELF_SERVICE_URL}?source=hotels-header`}
            data-testid="manage-bookings-link"
            target="_blank"
            rel="noreferrer noopener"
          >
            Manage bookings
          </HeaderInternalLink>
        </HeaderListItem>
      )}
      <HeaderLinks setIsPhoneMenuOpen={setIsPhoneMenuOpen} setIsQffMenuOpen={setIsQffMenuOpen} />
    </HeaderList>
  );
};

NavigationLinks.propTypes = {
  setIsPhoneMenuOpen: PropTypes.func.isRequired,
  setIsQffMenuOpen: PropTypes.func.isRequired,
};

export default NavigationLinks;
